import '../styles/main.scss';

  const e = {
    data: {
      target: ".animslider",
      slide_number: 0,
      routine_autoplayer: null,
      routine_build: null,
      routine_progress: null,
      first_init: !1,
    },
    elements: {
      parent: null,
      nav: null,
      nav_items: null,
      slides_parent: null,
      slides: null,
      videos: null,
      progress: null,
      active_video: null,
    },
    classes: {
      leaving: "leaving",
      left: "left",
      entering: "entering",
      here: "here",
      active: "active",
    },
    init() {
      (e.data.first_init = !1), e.methods.refresh(), (window.animslider = e);
    },
    methods: {
      assign() {
        (e.elements.parent = document.querySelector(e.data.target)),
          (e.elements.nav =
            e.elements.parent.querySelector(".animslider__nav")),
          (e.elements.nav_items = e.elements.parent.querySelectorAll(
            ".animslide__nav__list__item"
          )),
          (e.elements.slides_parent = e.elements.parent.querySelector(
            ".animslider__slides"
          )),
          (e.elements.slides = e.elements.parent.querySelectorAll(
            ".animslider__slides__slide"
          )),
          (e.elements.videos = e.elements.parent.querySelectorAll("video")),
          (e.elements.progress =
            e.elements.parent.querySelector(".progress__line"));
      },
      handlers: {
        on_init() {
          document.addEventListener("DOMContentLoaded", function () {
            (e.data.first_init = !1), e.methods.refresh();
          });
        },
      },
      refresh() {
        !1 !== document.body.contains(document.querySelector(e.data.target)) &&
          (e.methods.assign(), e.methods.autoplay());
      },
      autoplay() {
        let t = e.elements.slides_parent.querySelector(".active video");
        (e.elements.active_video = t),
          !1 === e.data.first_init
            ? e.methods.play_first_video()
            : (e.data.routine_autoplayer = setTimeout(() => {
                e.methods.set_slide_active(e.methods.get_next_slide());
              }, 1e3 * t.duration)),
          e.methods.start_progress();
      },
      start_progress() {
        null !== e.data.routine_progress &&
          clearTimeout(e.data.routine_progress),
          (e.elements.progress.style = "transition:none !important; width:0%"),
          (e.data.routine_progress = setInterval(() => {
            let t = Math.round(
              (e.elements.active_video.currentTime /
                e.elements.active_video.duration) *
                100
            );
            (t += 0.5),
              t > 100 && (t = 100),
              (e.elements.progress.style = `transition: all 0.1s linear; width:${t}%`);
          }));
      },
      get_next_slide() {
        let t = e.data.slide_number + 1;
        return t >= e.elements.slides.length && (t = 0), t;
      },
      click_set_slide_active(t) {
        clearTimeout(e.data.routine_autoplayer), e.methods.set_slide_active(t);
      },
      play_first_video() {

        // remove some kind of loading class
        // or add a ready class
        // then style it so that we don't see anything
        // until the class is loaded


        e.data.first_init = !0;
        let t = e.elements.slides[0],
          s = (t.dataset.style, t.querySelector("video"));
        null !== e.data.routine_build && clearTimeout(e.data.routine_build),
          (e.data.routine_build = setTimeout(() => {
            (t.dataset.status = e.classes.entering),
              (e.elements.parent.querySelector(".progress").style =
                "opacity: 1;"),
              (e.data.routine_build = setTimeout(() => {

                // Show the panel
                e.elements.parent.dataset.loaded = "true";

                e.methods.play_video(s),
                  e.methods.autoplay(),
                  (t.dataset.status = e.classes.here);
              }, 250));
          }, 250));
      },
      set_slide_active(t) {
        e.data.slide_number = t;
        let s = e.elements.slides_parent.querySelector(".active"),
          a = s.querySelector("video"),
          l = e.elements.slides[t],
          i = l.dataset.style,
          r = l.querySelector("video"),
          n = e.elements.nav_items[t];
        (s.dataset.status = e.classes.leaving),
          e.methods.clear_nav(),
          n.classList.add("active"),
          null !== e.data.routine_build && clearTimeout(e.data.routine_build),
          (e.data.routine_build = setTimeout(() => {
            (e.elements.parent.querySelector(".progress").style =
              "opacity: 0;"),
              (s.dataset.status = e.classes.left),
              (e.data.routine_build = setTimeout(() => {
                e.methods.clear_slides(),
                  e.methods.clear_video(a),
                  (e.elements.parent.dataset.style = i),
                  l.classList.add("active"),
                  e.methods.play_video(r),
                  e.methods.autoplay(),
                  (e.data.routine_build = setTimeout(() => {
                    (l.dataset.status = e.classes.entering),
                      (e.elements.parent.querySelector(".progress").style =
                        "opacity: 1;"),
                      (e.data.routine_build = setTimeout(() => {
                        l.dataset.status = e.classes.here;
                      }, 250));
                  }, 250));
              }, 250));
          }, 250));
      },
      play_video(e) {
        (e.autoplay = !0),
        //(e.muted = !0),
        (e.playsinline = !0),
        e.play();
      },
      clear_videos() {
        e.elements.videos.forEach((e) => {
          e.pause(),
            (e.currentTime = 0),
            (e.autoplay = !1),
            //(e.muted = !0),
            (e.playsinline = !1);
        });
      },
      clear_video(e) {
        e.pause(),
          (e.currentTime = 0),
          (e.dataset.reset = 0),
          (e.autoplay = 0),
          (e.loop = 0),
          //(e.muted = 0),
          (e.playsinline = 0);
      },
      clear_slides() {
        e.elements.slides.forEach((e) => {
          e.classList.remove("active");
        });
      },
      clear_nav() {
        e.elements.nav_items.forEach((e) => {
          e.classList.remove("active");
        });
      },
    },
  };

  e.init();
